import { render, staticRenderFns } from "./HeaderHomePage.vue?vue&type=template&id=8120282c"
import script from "./HeaderHomePage.vue?vue&type=script&lang=js"
export * from "./HeaderHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports